<template>
  <div>
    <!-- 一覧 -->
    <div>
      <div style="overflow: auto;">
        <div style="width: 300px; ">
          <b-table-filter :maxHeight="maxHeight" :filter_list="filter_list" :filter_val="filter_val"
            :data_list_field="data_list_field" :data_list="data_list" @on_edit='onEdit' @on_delete='onDelete'
            :filter_enable="true" :edit_disabled="pms_master_item < 2" />
        </div>
      </div>
      <div style="margin: 5px 0px 0px 0px">
        {{ data_list.length }}件&nbsp;&nbsp;
        <b-button @click="onEdit(-1)" ref="btnShow" variant="info" class="icon_btn_w"
          :disabled="pms_master_item < 2">
          <b-icon icon="plus" aria-hidden="true"></b-icon>
        </b-button>
      </div>
    </div>
    <!-- モーダル 商品type  -->
    <b-modal id="modal-item_type" :title="title" :header-bg-variant="'dark'" :header-text-variant="'light'"
      :body-bg-variant="'light'" hide-footer centered>
      <div class="modal_div">
        <div class="form-inline">
            <label>商品種別</label>
            <b-input v-model="item_type.type_name" type="text" style="width: 300px" />
          </div>

      </div>
      <div class="modal-footer">
        <b-button @click="$bvModal.hide('modal-item_type')">
          <b-icon icon="x"></b-icon>取消
        </b-button>
        <b-button @click="onDelete" variant="danger" class="" :disabled="this.item_type.id == null">
          <b-icon icon="save"></b-icon>&nbsp;削除
        </b-button>
        <b-button variant="primary" @click="onSave">
          <b-icon icon="save"></b-icon>&nbsp;保存
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';

// vue-good-table
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

const jsonpAdapter = require('axios-jsonp');
export default {
  props: ['modal_id'],
  components: {
  },
  data: function () {
    return {
      // table
      current_page: 1,
      busy: false,
      sort_by: '',
      sort_desc: true,
      where: "",
      filter_list: new Array(15),
      filter_val: new Array(15),
      filter_val_sign: new Array(15),
      data_list: [],
      data_count: 0,
      data_list_field: [
      { key: "edit", label: "編集", thStyle: { width: "60px", textAlign: "center" }, tdClass: 'text-center', sortable: false, filter: false, edit: true },
        { key: "type_name", label: "商品種別", thStyle: { }, sortable: true, filter: 'input', edit: true},
      ],
      // modal
      title: '',
      item_type: [],
      //
      msg: 'msg',
      showModal: false,
      deleteTarget: -1,
      errors: [],
      maxHeight: document.documentElement.scrollHeight - 250 + "px"
    }
  },
  mounted() {
    this.checkLogin();
    this.onFilterEx();
  },
  methods: {
    closeModal: function (id) {
      this.$emit('close_modal', id);
    },
    onFilterEx: function () {
      this.sel_id = []
      this.current_page = 1;
      this.getDataList();
    },
    // 一覧 取得
    getDataList: function () {
      this.busy = true
      axios
        .get('/master_item/get_item_type_list/', {
          params: {
          }
        })
        .then(response => {
          this.data_list = response.data.data_list;
          this.busy = false
        })
    },
    // 編集
    onEdit: function (id) {
      if (id == -1){
        this.title = "商品種別 > 追加"
      }else{
        this.title = "商品種別 > 編集"
      }
      axios
        .get(`/master_item/get_item_type/${id}`)
        .then(response => {
          this.item_type = response.data.data;
          this.$root.$emit('bv::show::modal', 'modal-item_type')
        })
    },
    // 削除
    onDelete: function () {
      if (confirm('削除しますか？')) {
        axios
          .delete(`/master_item/del_item_type/${this.item_type.id}`)
          .then(response => {
            if (response.data.flg){
              alert("削除しました。");
              this.$root.$emit('bv::hide::modal', 'modal-item_type')
              this.getDataList();
            }
          })
      }
    },
    // 保存
    onSave: function () {
      axios
        .patch(`/master_item/save_item_type`, { item_type: this.item_type })
        .then(response => {
          this.getDataList();
          this.$root.$emit('bv::hide::modal', 'modal-item_type')
        })
    },
    // ======================================================================================
    // モーダル保存
    onUpdate: function () {
    },
  }
}
</script>

<style scoped></style>